import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";
import { Page, PageContent, PageHeader } from "frame/components";
import NotFound from "./not-found";
import { ChildRoutes } from "./staff-routes";
import { useDispatch } from "react-redux";
import { useRouter, getVisibleStaffDirectoryIds, isInStaffDirectory } from "utils";
import {
	onAdd as onJobAdd,
	onTypeChanged,
	onStaffIdChanged,
} from "features/jobs/actions";
import { ADD_JOB_PATH } from "features/jobs/actions/types";

const useStyles = makeStyles((theme) => ({
	root: {},
	headerTitle: {
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(0.75),
		paddingBottom: theme.spacing(0.5),
	},
	headerRow: {
		display: "flex",
		flexWrap: "wrap",
		alignItems: "baseline",
		gap: theme.spacing(1),
		minWidth: 0,
	},
	headerLabel: {
		color: "#999999",
		fontSize: theme.typography.pxToRem(13),
		fontWeight: theme.typography.fontWeightRegular,
		lineHeight: 1.4,
		flexShrink: 0,
	},
	headerValueLarge: {
		color: theme.palette.brand,
		fontSize: theme.typography.pxToRem(24),
		fontWeight: 700,
		lineHeight: 1.2,
		letterSpacing: "0.06px",
	},
}));

const Staff = ({ person, profile }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { history } = useRouter();
	const directoryIds = getVisibleStaffDirectoryIds(
		profile && profile.role,
		profile && profile.supervisingStaffList
	);
	const canOpen = !!person && isInStaffDirectory(directoryIds, person.id);
	const visiblePerson = canOpen ? person : null;

	const name = (visiblePerson && visiblePerson.fullName) || "Not Found";

	const onAddPhotoNote = () => {
		if (!visiblePerson?.id) {
			return;
		}
		dispatch(onJobAdd());
		dispatch(onTypeChanged("staff"));
		dispatch(onStaffIdChanged(visiblePerson.id));
		history.push(ADD_JOB_PATH);
	};

	const pageTitle = (
		<div className={classes.headerTitle} data-cy="staff-detail-header">
			<div className={classes.headerRow}>
				<Typography
					component="span"
					className={classes.headerLabel}
					data-cy="staff-detail-label"
				>
					Staff
				</Typography>
				<Typography
					component="h1"
					className={classes.headerValueLarge}
					data-cy="staff-detail-name"
				>
					{name}
				</Typography>
			</div>
		</div>
	);

	return (
		<Page className={classes.root} title="Staff">
			<PageHeader title={pageTitle} />
			{visiblePerson ? (
				<PageContent>
					<ChildRoutes onAddPhotoNote={onAddPhotoNote} />
				</PageContent>
			) : (
				<PageContent pad>
					<NotFound />
				</PageContent>
			)}
		</Page>
	);
};

Staff.propTypes = {
	person: PropTypes.object,
	profile: PropTypes.object,
};

export default Staff;
